module.exports = "<app-nav-menu></app-nav-menu>\r\n<app-notify></app-notify>\r\n<div ui-view class=\"o-wrapper--limit o-wrapper--reset container-fluid\">\r\n      <div class=\"container-fluid\">\r\n            <router-outlet></router-outlet>\r\n      </div>\r\n</div>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/app/components/app/app.component.html
// module id = ../../../../../src/app/components/app/app.component.html
// module chunks = main